var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.hasBrand)?_c('selected-manufacturer',{attrs:{"destinationRouteName":'daily'},on:{"brand-selected":_vm.handleBrandSelected}}):_c('daily',{attrs:{"marca-seleccionada":_vm.marcaSeleccionada},on:{"go-back":_vm.handleGoBack}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }